$(document).ready(function() {
  // Replace the SVG inside the button with the "Submit" text
  $(".newsletter-form__button svg").replaceWith("<span>Submit</span>");
});